import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Service} from '../../../core/entities/service/service.entity';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceService
{
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public createService(
    name: string,
    description: string | null,
    duration: number,
    price: number|null,
    priceRangeActive: boolean,
    priceRangeMin: number|null,
    priceRangeMax: number|null,
    discountActive: boolean|null,
    discount: number|null,
    online: boolean,
    allowDeposit: boolean,
    depositPercentage: number|null,
    advantages: string[] = [],
    image: File | null = null,
    photos: File[] = [],
  ): Observable<Service> {
    const formData = new FormData();

    let priceRange = null;
    if (priceRangeActive) {
      priceRange = {
        min: priceRangeMin,
        max: priceRangeMax
      };
    }

    let data = {
      name,
      description,
      duration,
      price,
      priceRange,
      discountActive,
      discount,
      online,
      allowDeposit,
      depositPercentage: allowDeposit ? depositPercentage : null,
      advantages
    };

    formData.append('data', JSON.stringify(data));

    if (image) {
      formData.append('picture', image);
    }

    photos.forEach((photo) => formData.append('photos[]', photo));

    return this.http.post<Service>(`${environment.apiUrl}/manage/service`, formData);
  }

  public getServices(): Observable<Service[]> {
    return this.http.get<Service[]>(`${environment.apiUrl}/manage/service`);
  }

  public editService(
    service: Service,
    name: string,
    description: string | null,
    duration: number,
    price: number,
    priceRangeActive: boolean,
    priceRangeMin: number|null,
    priceRangeMax: number|null,
    discountActive: boolean|null,
    discount: number|null,
    online: boolean,
    allowDeposit: boolean,
    depositPercentage: number|null,
    advantages: string[] = [],
    image: File | null = null,
    photos: File[] = [],
  ): Observable<Service> {
    const formData = new FormData();

    let priceRange = null;
    if (priceRangeActive) {
      priceRange = {
        min: priceRangeMin,
        max: priceRangeMax
      };
    }

    let data = {
      name,
      description,
      duration,
      price,
      priceRange,
      discountActive,
      discount,
      online,
      allowDeposit,
      depositPercentage: allowDeposit ? depositPercentage : null,
      advantages
    };

    formData.append('data', JSON.stringify(data));

    if (image) {
      formData.append('picture', image);
    }

    photos.forEach((photo) => formData.append('photos[]', photo));

    return this.http.post<Service>(`${environment.apiUrl}/manage/service/${service.id}/edit`, formData);
  }

  public deleteService(service: Service): Observable<null> {
    return this.http.delete<null>(`${environment.apiUrl}/manage/service/${service.id}`);
  }

  /**
   * Update the order of a photographer services
   * @param orderedServices { id, position } service id and service position
   */
  public updateOrder(orderedServices: { id: number; position: number }[]): Observable<{ success: boolean }> {
    return this.http.put<{ success: boolean }>(
      `${environment.apiUrl}/manage/service/order`,
      orderedServices
    );
  }
}
